<template>
  <b-container data-app fluid>
    <b-row>
      <b-col md="12">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title title-typography-color">
              <i class="fas fa-file-medical"></i>
              {{ $t("public.views.Pages.Professional.Contact.Recipes.title") }}
              <span v-if="patient !== null && patient.name">
                - {{ patient.name }} {{ patient.lastname }} (
                {{ patient.document }} )
              </span>
            </h4>
          </template>
          <template v-slot:headerAction>
            <b-button v-if="
              validateRecipe &&
              checkPermissionProfessional('CONTACT_RECIPES', ['CREATE'])
            " ref="btnShowNewVisit" class="mr-2" style="right" variant="success" @click="openModal">{{
  $t("public.views.Pages.Professional.Contact.Recipes.btnCreate")
}}
            </b-button>
            <b-button v-if="patient !== null && patient.name" right variant="primary" @click="backContacts">{{
              $t("generic.btnBack")
            }}
            </b-button>
          </template>
          <template v-if="checkPermissionProfessional('CONTACT_RECIPES', ['LIST'])" v-slot:body>
            <b-alert v-if="!validateRecipe" show variant="warning">
              {{
                $t(
                  "public.views.Pages.Professional.Contact.Recipes.userNotValidated"
                )
              }}
            </b-alert>
            <div class="text-right">
              <b-button class="mb-3 mr-1" variant="secondary" @click="getRecipesExcel()">
                Excel
              </b-button>
            </div>
            <div>
              <v-card-title>
                <v-text-field v-model="search" hide-details single-line @blur="getAllRecipe">
                  <template slot="label">
                    <div class="search-datatable">
                      <i class="fas fa-search fa-fw"></i>
                      {{
                        $t(
                          "public.views.Pages.Professional.Contact.Recipes.search"
                        )
                      }}
                    </div>
                  </template>
                </v-text-field>
                <b-button class="mt-3 ml-2" variant="primary" @click="getAllRecipe">
                  {{
                    $t("public.views.Pages.Professional.Contact.Recipes.search")
                  }}
                </b-button>
              </v-card-title>
              <v-data-table :footer-props="{
                showFirstLastPage: true,
                firstIcon: 'fas fa-arrow-left',
                lastIcon: 'fas fa-arrow-right',
                prevIcon: 'fas fa-minus',
                nextIcon: 'fas fa-plus',
                'items-per-page-options': [10, 25, 50],
              }" :headers="headers" :items="recipes" :options.sync="pagination" :search="search"
                :server-items-length="total" item-key="id">
                <template v-slot:item.professional="{ item }">
                  <b-list-group-item v-if="item.patient" class="d-flex align-items-center border-0 p-0">
                    <b-avatar v-bind:src="
                      item.professional.avatarUrl
                        ? item.professional.avatarUrl +
                        '/' +
                        getAuthentication()
                        : ''
                    "></b-avatar>
                    <div class="media-support-info ml-3">
                      <p class="mb-0 font-size-16">
                        {{ item.professional.name }}
                      </p>
                      <p class="mb-0 font-size-12">
                        {{ item.professional.lastname }}
                      </p>
                    </div>
                  </b-list-group-item>
                </template>
                <template v-slot:item.patient="{ item }">
                  <b-list-group-item v-if="item.patient" class="d-flex align-items-center border-0 p-0">
                    <b-avatar v-bind:src="
                      item.patient.avatarUrl
                        ? item.patient.avatarUrl +
                        '/' +
                        getAuthentication()
                        : ''
                    "></b-avatar>
                    <div class="media-support-info ml-3">
                      <p class="mb-0 font-size-16">{{ item.patient.name }}</p>
                      <p class="mb-0 font-size-12">
                        {{ item.patient.lastname }}
                      </p>
                    </div>
                  </b-list-group-item>
                </template>
                <template v-slot:item.dispensationDate="{ item }">
                  <div v-if="item.dispensationDate">
                    {{ item.dispensationDate | adjustToTimezone("DD/MM/YYYY") }}
                  </div>
                </template>
                <template v-slot:item.id="{ item }">
                  <div class="div-table-data">
                    <button :id="'btnSee' + item.id" class="item" v-on:click="getRecipe(item.id)">
                      <i class="ri-eye-line"></i>
                    </button>
                    <b-popover :target="'btnSee' + item.id" placement="botton" triggers="hover focus">
                      <template #title>{{
                        $t(
                          "public.views.Pages.Professional.Contact.Recipes.btnSee"
                        )
                      }}
                      </template>
                    </b-popover>
                    <button :id="'btnDwn' + item.id" class="item" v-on:click="getRecipePdf(item.id)">
                      <i class="ri-file-download-line"></i>
                    </button>
                    <b-popover :target="'btnDwn' + item.id" placement="botton" triggers="hover focus">
                      <template #title>{{
                        $t(
                          "public.views.Pages.Professional.Contact.Recipes.btnDwn"
                        )
                      }}
                      </template>
                    </b-popover>
                    <button v-if="
                      checkPermissionProfessional('CONTACT_RECIPES', ['EDIT'])
                    " :id="'btnSend' + item.id" class="item" v-on:click="sendRecipe(item.id)">
                      <i class="ri-mail-send-line"></i>
                    </button>
                    <b-popover v-if="
                      checkPermissionProfessional('CONTACT_RECIPES', ['EDIT'])
                    " :target="'btnSend' + item.id" placement="botton" triggers="hover focus">
                      <template #title>{{
                        $t(
                          "public.views.Pages.Professional.Contact.Recipes.btnSend"
                        )
                      }}
                      </template>
                    </b-popover>
                  </div>
                </template>
              </v-data-table>
              <b-modal id="modal-new-recipe" :hide-footer="disabled" centered size="lg" @ok="saveFormStep1">
                <template #modal-title>
                  <div v-if="!disabled">
                    {{
                      $t(
                        "public.views.Pages.Professional.Contact.Recipes.modalCreate.title"
                      )
                    }}
                  </div>
                  <div v-else>
                    {{
                      $t(
                        "public.views.Pages.Professional.Contact.Recipes.modalCreate.seeRecipes"
                      )
                    }}
                  </div>
                </template>
                <template #modal-ok>{{
                  $t(
                    "public.views.Pages.Professional.Contact.Recipes.modalCreate.save"
                  )
                }}
                </template>
                <template #modal-cancel>{{
                  $t(
                    "public.views.Pages.Professional.Contact.Recipes.modalCreate.close"
                  )
                }}
                </template>
                <form action="#">
                  <template class="header-title">
                    <h4 class="card-title">
                      {{
                        $t(
                          "public.views.Pages.Professional.Contact.Recipes.modalCreate.destinatary"
                        )
                      }}
                    </h4>
                  </template>
                  <hr />
                  <b-form-group label-for="name">
                    <template slot="label">{{
                      $t(
                        "public.views.Pages.Professional.Contact.Recipes.modalCreate.destinatary_Name"
                      )
                    }}: *
                    </template>

                    <multiselect v-model="patient" :clear-on-select="false" :close-on-select="false" :disabled="disabled"
                      :multiple="false" :options="patientSelect" :preselect-first="true" :preserve-search="true"
                      label="text" track-by="value" v-bind:deselectGroupLabel="
                        $t(
                          'public.views.Pages.Professional.Contact.Recipes.multiselect.deselectGroupLabel'
                        )
                      " v-bind:deselectLabel="
  $t(
    'public.views.Pages.Professional.Contact.Recipes.multiselect.deselectLabel'
  )
" v-bind:placeholder="
  $t(
    'public.views.Pages.Professional.Contact.Recipes.multiselect.placeholder'
  )
" v-bind:selectGroupLabel="
  $t(
    'public.views.Pages.Professional.Contact.Recipes.multiselect.selectGroupLabel'
  )
" v-bind:selectLabel="
  $t(
    'public.views.Pages.Professional.Contact.Recipes.multiselect.selectLabel'
  )
" v-bind:selectedLabel="
  $t(
    'public.views.Pages.Professional.Contact.Recipes.multiselect.selectedLabel'
  )
">
                      <template slot="option" slot-scope="props">
                        <b-list-group-item class="d-flex align-items-center">
                          <b-avatar class="mr-3" v-bind:src="props.option.avatar"></b-avatar>
                          <span class="mr-auto title-typography-color">{{
                            props.option.text
                          }}</span>
                        </b-list-group-item>
                      </template>
                      <template slot="selection" slot-scope="{ values, isOpen }"><span v-if="values.length && !isOpen"
                          class="multiselect__single">{{ values.length }}
                          {{
                            $t(
                              "public.views.Pages.Professional.Contact.Recipes.selectedOrganizations"
                            )
                          }}</span></template>
                      <template v-if="props.option.text" slot="singleLabel" slot-scope="props"><span
                          class="option__desc"><span class="option__title">
                            <b-avatar class="mr-3" v-bind:src="props.option.avatar"></b-avatar><span
                              class="mr-auto title-typography-color">{{
                                props.option.text
                              }}</span>
                          </span></span></template>
                    </multiselect>

                    <ul v-if="isFormNameErrors">
                      <li v-for="(error, index) in validatorStep1.getErrors(
                        'name'
                      )" v-bind:key="index" class="form-text text-danger">
                        &nbsp;{{ error }}
                      </li>
                    </ul>
                  </b-form-group>

                  <b-form-group v-if="patient && patient.validatedBy === null" label-for="validatedProfessional">
                    <template slot="label">He validado al paciente</template>
                    <b-form-checkbox id="validatedProfessional" v-model="validatedProfessional" :disabled="disabled"
                      size="lg" switch></b-form-checkbox>
                  </b-form-group>

                  <template class="header-title">
                    <h4 class="card-title">
                      {{
                        $t(
                          "public.views.Pages.Professional.Contact.Recipes.modalCreate.prescription_Title"
                        )
                      }}
                    </h4>
                  </template>
                  <hr />
                  <b-form-group label-for="medicine">
                    <template slot="label">{{
                      $t(
                        "public.views.Pages.Professional.Contact.Recipes.modalCreate.prescription_Medicine"
                      )
                    }}: *
                    </template>
                    <b-form-textarea id="medicine" v-model="medicine" :disabled="disabled" size="lg" v-bind:class="{
                      'text-danger': isFormMedicineErrors,
                      'is-invalid': isFormMedicineErrors,
                    }" @blur="checkMedicine(medicine)"></b-form-textarea>
                    <ul v-if="isFormMedicineErrors">
                      <li v-for="(error, index) in validatorStep1.getErrors(
                        'medicine'
                      )" v-bind:key="index" class="form-text text-danger">
                        &nbsp;{{ error }}
                      </li>
                    </ul>
                  </b-form-group>
                  <b-form-group label-for="presentation">
                    <template slot="label">{{
                      $t(
                        "public.views.Pages.Professional.Contact.Recipes.modalCreate.prescription_Concentration"
                      )
                    }}: *
                    </template>
                    <b-form-textarea id="presentation" v-model="presentation" :disabled="disabled" size="lg" v-bind:class="{
                      'text-danger': isFormPresentationErrors,
                      'is-invalid': isFormPresentationErrors,
                    }" @blur="checkPresentation(presentation)"></b-form-textarea>
                    <ul v-if="isFormPresentationErrors">
                      <li v-for="(error, index) in validatorStep1.getErrors(
                        'presentation'
                      )" v-bind:key="index" class="form-text text-danger">
                        &nbsp;{{ error }}
                      </li>
                    </ul>
                  </b-form-group>
                  <b-form-group label-for="units">
                    <template slot="label">{{
                      $t(
                        "public.views.Pages.Professional.Contact.Recipes.modalCreate.prescription_Units"
                      )
                    }}: *
                    </template>
                    <b-form-textarea id="units" v-model="units" :disabled="disabled" size="lg" v-bind:class="{
                      'text-danger': isFormUnitsErrors,
                      'is-invalid': isFormUnitsErrors,
                    }" @blur="checkUnits(units)"></b-form-textarea>
                    <ul v-if="isFormUnitsErrors">
                      <li v-for="(error, index) in validatorStep1.getErrors(
                        'units'
                      )" v-bind:key="index" class="form-text text-danger">
                        &nbsp;{{ error }}
                      </li>
                    </ul>
                  </b-form-group>
                  <template class="header-title">
                    <h4 class="card-title">
                      {{
                        $t(
                          "public.views.Pages.Professional.Contact.Recipes.modalCreate.posology"
                        )
                      }}:
                    </h4>
                  </template>
                  <hr />
                  <b-form-group label-for="posology">
                    <template slot="label">{{
                      $t(
                        "public.views.Pages.Professional.Contact.Recipes.modalCreate.posology"
                      )
                    }}:
                    </template>
                    <b-form-input id="posology" v-model="posology" :disabled="disabled"></b-form-input>
                  </b-form-group>
                  <b-form-group label-for="unitsPosology">
                    <template slot="label">{{
                      $t(
                        "public.views.Pages.Professional.Contact.Recipes.modalCreate.posology_Units"
                      )
                    }}:
                    </template>
                    <b-form-input id="unitsPosology" v-model="unitsPosology" :disabled="disabled"
                      type="number"></b-form-input>
                  </b-form-group>
                  <b-form-group label-for="pattern">
                    <template slot="label">{{
                      $t(
                        "public.views.Pages.Professional.Contact.Recipes.modalCreate.posology_Pattern"
                      )
                    }}
                      :
                    </template>
                    <b-form-input id="pattern" v-model="pattern" :disabled="disabled"></b-form-input>
                  </b-form-group>
                  <template class="header-title">
                    <h4 class="card-title">
                      {{
                        $t(
                          "public.views.Pages.Professional.Contact.Recipes.modalCreate.treatment"
                        )
                      }}
                    </h4>
                  </template>
                  <hr />
                  <b-form-group label-for="duration">
                    <template slot="label">{{
                      $t(
                        "public.views.Pages.Professional.Contact.Recipes.modalCreate.treatment_Duration"
                      )
                    }}:
                    </template>
                    <b-form-input id="duration" v-model="duration" :disabled="disabled"></b-form-input>
                  </b-form-group>
                  <b-form-group label-for="orderNumber">
                    <template slot="label">{{
                      $t(
                        "public.views.Pages.Professional.Contact.Recipes.modalCreate.treatment_OrderNumber"
                      )
                    }}:
                    </template>
                    <b-form-input id="orderNumber" v-model="orderNumber" :disabled="disabled"></b-form-input>
                  </b-form-group>
                  <b-form-group label-for="dispensationDate">
                    <template slot="label">{{
                      $t(
                        "public.views.Pages.Professional.Contact.Recipes.modalCreate.treatment_DispensationDate"
                      )
                    }}:
                    </template>
                    <b-form-input id="dispensationDate" v-model="dispensationDate" :disabled="disabled"
                      type="date"></b-form-input>
                  </b-form-group>
                  <template class="header-title">
                    <h4 class="card-title">
                      {{
                        $t(
                          "public.views.Pages.Professional.Contact.Recipes.modalCreate.comments"
                        )
                      }}
                    </h4>
                  </template>
                  <hr />
                  <b-form-group label-for="comments">
                    <template slot="label">{{
                      $t(
                        "public.views.Pages.Professional.Contact.Recipes.modalCreate.comments"
                      )
                    }}:
                    </template>
                    <b-form-textarea id="comments" v-model="comments" :disabled="disabled" size="lg"></b-form-textarea>
                  </b-form-group>
                </form>
              </b-modal>
            </div>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <notifications group="notificacions" />
  </b-container>
</template>
<script>
import { xray } from "../../../../config/pluginInit";

import validator from "vue-m-validator";

import moment from "moment";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";

import patientService from "../../../../services/patient";
import professionalService from "../../../../services/professional";
import recipeService from "../../../../services/recipe";
import utilsService from "../../../../services/utils";

export default {
  name: "Recipes",
  watch: {
    pagination: {
      handler() {
        if (this.start) {
          this.getAllRecipe();
        }
        this.start = true;
      },
    },
  },
  mounted() {
    xray.index();
    this.getProfessional();

    this.getAllRecipe();

    this.getAllPatientsSelect();

    utilsService.auditActivity({ action: "VIEW", module: "PROFESSIONAL_RECIPES", info: "" });
  },
  computed: {
    validateRecipe() {
      return this.professional && this.professional.validateRecipe;
    },
    isFormNameErrors() {
      let errors = this.validatorStep1.getErrors("name");
      return errors && errors.length > 0;
    },
    isFormMedicineErrors() {
      let errors = this.validatorStep1.getErrors("medicine");
      return errors && errors.length > 0;
    },
    isFormPresentationErrors() {
      let errors = this.validatorStep1.getErrors("presentation");
      return errors && errors.length > 0;
    },
    isFormUnitsErrors() {
      let errors = this.validatorStep1.getErrors("units");
      return errors && errors.length > 0;
    },
  },
  methods: {
    getAuthentication() {
      return localStorage.getItem('authorization');
    },
    changePatient() {
      console.log(this.patient);
      if (this.patient && this.patient.validatedBy === null) {
        this.validatedProfessional = false;
      } else {
        this.validatedProfessional = true;
      }
    },
    checkPermissionProfessional(permission, permissionType) {
      return utilsService.checkPermissionProfessional(
        permission,
        permissionType
      );
    },
    backContacts() {
      this.$router.push({
        name: "auth.professional.contact.contacts",
      });
    },
    createRecipe() {
      let self = this;

      if (
        (this.patient && this.patient.validatedBy !== null) ||
        this.validatedProfessional
      ) {
        var data = {
          name: this.patient.value,
          medicine: this.medicine,
          presentation: this.presentation,
          units: this.units,
          posology: this.posology,
          unitsPosology: this.unitsPosology,
          pattern: this.pattern,
          duration: this.duration,
          orderNumber: this.orderNumber,
          dispensationDate: this.dispensationDate
            ? moment(this.dispensationDate)
            : "",
          comments: this.comments,
          validatedProfessional: this.validatedProfessional,
        };
        this.$awn.asyncBlock(
          recipeService.create(data),
          (response) => {
            if (response) {
              utilsService.auditActivity({ action: "CREATE", module: "PROFESSIONAL_RECIPES", info: "" });
              self.$bvModal.hide("modal-new-recipe");
              self.$notify({
                group: "notificacions",
                title: this.$i18n.t(
                  "public.views.Pages.Professional.Contact.Recipes.notification.title"
                ),
                text: this.$i18n.t(
                  "public.views.Pages.Professional.Contact.Recipes.notification.descCreated"
                ),
                type: "success",
              });
              self.getAllRecipe();
            }
          },
          (error) => {
            utilsService.auditErrorFrontent({
              info: "recipeService.create",
              module: "view-pages-professional-contact-recipes",
              httpStatus: error.response ? error.response.status : null,
              endpoint: window.location.href,
              request: JSON.stringify({
                data: data
              })
            });
          },
          " "
        );
      } else {
        self.$swal(
          "Paciente no validado",
          "Tiene que aceptar el check de validar paciente",
          "error"
        );
      }
    },
    async getAllRecipe() {
      let self = this;

      let filter = {
        filter: this.search,
      };

      this.$awn.asyncBlock(
        recipeService.getAll(
          this.pagination.page - 1,
          this.pagination.itemsPerPage,
          filter
        ),
        (response) => {
          if (response) {
            self.recipes = response.data.content;
            self.total = response.data.pageable.total;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "recipeService.getAll",
            module: "view-pages-professional-contact-recipes",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              page: this.pagination.page - 1,
              itemsPerPage: this.pagination.itemsPerPage,
              filter: filter
            })
          });
        }
      );
    },
    getRecipe(id) {
      let self = this;

      this.$awn.asyncBlock(
        recipeService.get(id),
        (response) => {
          if (response) {
            self.disabled = true;
            self.patient = self.patientSelect.find(
              (option) => option.value === response.data.patient.id
            );
            self.medicine = response.data.medicine;
            self.presentation = response.data.presentation;
            self.units = response.data.units;
            self.posology = response.data.posology;
            self.unitsPosology = response.data.unitsPosology;
            self.pattern = response.data.pattern;
            self.duration = response.data.duration;
            self.orderNumber = response.data.orderNumber;
            self.dispensationDate = response.data.dispensationDate;
            self.comments = response.data.comments;

            if (self.validatedProfessional !== null) {
              self.validatedProfessional = response.data.validatedProfessional;
            }

            self.$bvModal.show("modal-new-recipe");
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "recipeService.get",
            module: "view-pages-professional-contact-recipes",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              id: id
            })
          });
        },
        " "
      );
    },
    async getProfessional() {
      let self = this;

      professionalService
        .get(localStorage.getItem("userId"))
        .then((response) => {
          if (response) {
            self.professional = response.data;
          }
        })
        .catch((error) => {
          utilsService.auditErrorFrontent({
            info: "professionalService.get",
            module: "view-pages-professional-contact-recipes",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              userId: localStorage.getItem("userId")
            })
          });
        });
    },
    async getAllPatientsSelect() {
      let self = this;

      patientService
        .getAllActive()
        .then((response) => {
          let combo = [];
          response.data.forEach(function (item) {
            let data = {
              avatar: item.avatarUrl,
              value: item.id,
              validatedBy: item.validatedBy,
              text:
                item.name + " " + item.lastname + " (" + item.document + ") ",
            };
            combo.push(data);
          });
          self.patientSelect = combo;
        })
        .catch((error) => {
          utilsService.auditErrorFrontent({
            info: "patientService.getAllActive",
            module: "view-pages-professional-contact-recipes",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: null
          });
        });
    },
    sendRecipe(id) {
      if (this.professional.uuidSignature) {
        let self = this;

        this.$awn.asyncBlock(
          recipeService.send(id),
          (response) => {
            if (response) {
              utilsService.auditActivity({ action: "CREATE", module: "PROFESSIONAL_RECIPES_SEND", info: "" });
              this.$notify({
                group: "notificacions",
                title: this.$i18n.t(
                  "public.views.Pages.Professional.Contact.Recipes.notification.title"
                ),
                text: this.$i18n.t(
                  "public.views.Pages.Professional.Contact.Recipes.notification.descSend"
                ),
                type: "success",
              });
            }
          },
          (error) => {
            utilsService.auditErrorFrontent({
              info: "recipeService.send",
              module: "view-pages-professional-contact-recipes",
              httpStatus: error.response ? error.response.status : null,
              endpoint: window.location.href,
              request: JSON.stringify({
                id: id
              })
            });
          },
          " "
        );
      } else {
        this.$swal({
          title: this.$i18n.t(
            "public.views.Pages.Professional.Contact.Recipes.alert.signature.send.title"
          ),
          text: this.$i18n.t(
            "public.views.Pages.Professional.Contact.Recipes.alert.signature.send.content"
          ),
          type: "warning",
          showCancelButton: false,
          confirmButtonText: this.$i18n.t(
            "public.views.Pages.Professional.Contact.Recipes.alert.signature.send.btnGo"
          ),
          showCloseButton: true,
          showLoaderOnConfirm: true,
        }).then((result) => {
          if (result.value) {
            this.$router.push({
              name: "auth.professional.account",
            });
          }
        });
      }
    },
    getRecipesExcel() {
      if (this.search) {
        var objectUrl =
          process.env.VUE_APP_BASE_URL_CORE +
          "auth/recipes/excel?filter=" +
          this.search +
          "&token=" +
          localStorage.getItem("authorization");
      } else {
        var objectUrl =
          process.env.VUE_APP_BASE_URL_CORE +
          "auth/recipes/excel?token=" +
          localStorage.getItem("authorization");
      }
      utilsService.auditActivity({ action: "CREATE", module: "PROFESSIONAL_RECIPES_EXCEL", info: "" });
      window.open(objectUrl);
    },
    getRecipePdf(id) {
      if (this.professional.uuidSignature) {
        let self = this;

        this.$awn.asyncBlock(
          recipeService.getPdf(id),
          (response) => {
            if (response) {
              utilsService.auditActivity({ action: "CREATE", module: "PROFESSIONAL_RECIPES_PDF", info: "" });
              var byteCharacters = atob(response.data.data);
              var byteNumbers = new Array(byteCharacters.length);
              for (var i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
              }
              var byteArray = new Uint8Array(byteNumbers);
              var file = new Blob([byteArray], {
                type: "application/pdf;base64",
              });
              var fileURL = URL.createObjectURL(file);

              var fileLink = document.createElement("a");

              fileLink.href = fileURL;
              fileLink.setAttribute("download", "receta.pdf");
              document.body.appendChild(fileLink);

              fileLink.click();
              this.$notify({
                group: "notificacions",
                title: this.$i18n.t(
                  "public.views.Pages.Professional.Contact.Recipes.notification.title"
                ),
                text: this.$i18n.t(
                  "public.views.Pages.Professional.Contact.Recipes.notification.descCreated"
                ),
                type: "success",
              });
            }
          },
          (error) => {
            utilsService.auditErrorFrontent({
              info: "recipeService.getPdf",
              module: "view-pages-professional-contact-recipes",
              httpStatus: error.response ? error.response.status : null,
              endpoint: window.location.href,
              request: JSON.stringify({
                id: id
              })
            });
          },
          " "
        );
      } else {
        this.$swal({
          title: this.$i18n.t(
            "public.views.Pages.Professional.Contact.Recipes.alert.signature.generate.title"
          ),
          text: this.$i18n.t(
            "public.views.Pages.Professional.Contact.Recipes.alert.signature.generate.content"
          ),
          type: "warning",
          showCancelButton: false,
          confirmButtonText: this.$i18n.t(
            "public.views.Pages.Professional.Contact.Recipes.alert.signature.generate.btnGo"
          ),
          showCloseButton: true,
          showLoaderOnConfirm: true,
        }).then((result) => {
          if (result.value) {
            this.$router.push({
              name: "auth.professional.account",
            });
          }
        });
      }
    },
    notFirst() {
      this.isFirstRun = false;
    },
    checkName(_name) {
      const NAME = _name != null ? _name.toString() : null;
      const RULE_1 = {
        expression: !NAME || NAME === "",
        name: "name",
        msg: this.$i18n.t(
          "public.views.Pages.Professional.Contact.Recipes.errors.erName"
        ),
      };
      this.validatorStep1.addRule(RULE_1);
      this.notFirst();
    },
    checkMedicine(_medicine) {
      const MEDICINE = _medicine.trim();
      const RULE_1 = {
        expression: !MEDICINE || MEDICINE === "",
        name: "medicine",
        msg: this.$i18n.t(
          "public.views.Pages.Professional.Contact.Recipes.errors.erMedicine"
        ),
      };
      this.validatorStep1.addRule(RULE_1);
      this.notFirst();
    },
    checkPresentation(_presentation) {
      const PRESENTATION = _presentation.trim();
      const RULE_1 = {
        expression: !PRESENTATION || PRESENTATION === "",
        name: "presentation",
        msg: this.$i18n.t(
          "public.views.Pages.Professional.Contact.Recipes.errors.erPresentation"
        ),
      };
      this.validatorStep1.addRule(RULE_1);
      this.notFirst();
    },
    checkUnits(_units) {
      const UNITS = _units.trim();
      const RULE_1 = {
        expression: !UNITS || UNITS === "",
        name: "units",
        msg: this.$i18n.t(
          "public.views.Pages.Professional.Contact.Recipes.errors.erUnits"
        ),
      };
      this.validatorStep1.addRule(RULE_1);
      this.notFirst();
    },
    checkPattern(_pattern) {
      const PATTERN = _pattern.trim();
      const RULE_1 = {
        expression: !PATTERN || PATTERN === "",
        name: "pattern",
        msg: this.$i18n.t(
          "public.views.Pages.Professional.Contact.Recipes.errors.erPattern"
        ),
      };
      this.validatorStep1.addRule(RULE_1);
      this.notFirst();
    },
    checkFormStep1() {
      this.checkName(this.patient.value);
      this.checkMedicine(this.medicine);
      this.checkPresentation(this.presentation);
      this.checkUnits(this.units);
    },
    saveFormStep1(evt) {
      evt.preventDefault();
      this.checkFormStep1();
      if (this.validatorStep1.errors.length === 0) {
        //Call service to store data
        this.createRecipe();
      } else {
        this.$notify({
          group: "notificacions",
          title: this.$i18n.t(
            "public.views.Pages.Professional.Contact.Recipes.errors.erTitle"
          ),
          text: this.$i18n.t(
            "public.views.Pages.Professional.Contact.Recipes.errors.erStep1"
          ),
          type: "error",
        });
      }
    },
    clearForm() {
      this.patient = {};
      this.medicine = "";
      this.presentation = "";
      this.units = "";
      this.posology = "";
      this.unitsPosology = 0;
      this.pattern = "";
      this.duration = "";
      this.orderNumber = "";
      this.dispensationDate = "";
      this.comments = "";
    },
    openModal() {
      this.disabled = false;
      this.clearForm();
      this.validatorStep1.errors = [];
      this.$bvModal.show("modal-new-recipe");
    },
  },
  data() {
    return {
      start: false,
      total: 0,
      pagination: {},
      //Modal
      name: "",
      medicine: "",
      presentation: "",
      units: "",
      posology: "",
      unitsPosology: 0,
      pattern: "",
      duration: "",
      orderNumber: "",
      dispensationDate: "",
      comments: "",
      validatedProfessional: false,

      disabled: false,
      validatorStep1: validator,
      isValidateStep1: false,

      search: "",
      patientSelect: [],
      headers: [
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Contact.Recipes.headers.patient"
          ),
          align: "start",
          value: "patient",
        },
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Contact.Recipes.headers.professional"
          ),
          align: "start",
          value: "professional",
        },
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Contact.Recipes.headers.emisionDate"
          ),
          value: "dispensationDate",
        },
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Contact.Recipes.headers.prescription"
          ),
          value: "medicine",
        },
        { text: "", value: "id" },
      ],
      recipes: [],
      //Professional row datatable
      professional: [],
      //Patient object
      patient: {},
    };
  },
  components: {
    Multiselect,
  },
};
</script>
